import { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import { Box, Button, Typography, } from '@mui/material';
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import { API_SERVER } from '../settings';
export default function CreateAccountForm() {
    const [username, setUsername] = useState()
    const [password, setPassword] = useState()
    const [email, setEmail] = useState()
    const [error, setError] = useState()
    const [success, setSuccess] = useState()
    const fieldStyles = { paddingBottom: "1rem" }
    const navigate = useNavigate()

    const handleSubmit = () => {
        if (username && password && email) {
            axios.post(`${API_SERVER}/api/auth/create-user/`, {
                username: username,
                password: password,
                email: email
            }).then((res) => {
                if (res.data['error']) {
                    setError(res.data.error)
                } else if (res.data['success']) {
                    setSuccess(res.data.success)
                }
            }).catch((err) => {
                console.log(err)
                // validation cases should be handled server side
            })
        }
    }

    const handleUsernameChange = (e) => {
        setUsername(e.target.value)
    }

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
    }

    const handleEmailChange = (e) => {
        setEmail(e.target.value)
    }

    useEffect(() => {
        if (success) {
            setError()
            const timer = setTimeout(() => {
                console.log('This will run after 1 second!')
                navigate('/login')
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [success])

    return (
        <Box>
            <TextField required fullWidth id="name" label="Username" variant="outlined" onChange={handleUsernameChange} sx={fieldStyles} />
            <TextField required fullWidth id="role" label="Password" variant="outlined" onChange={handlePasswordChange} sx={fieldStyles} />
            <TextField required fullWidth id="role" label="Email Address" variant="outlined" onChange={handleEmailChange} sx={fieldStyles} />
            {error ? <Typography color='red'>{error}</Typography> : null}
            {success ? <Typography color='secondary'>{success}</Typography> : null}
            {success ? null : (
                <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    color="secondary"
                    onClick={handleSubmit}
                    sx={{ marginTop: "1.65rem", color: "white" }}>
                    <Typography variant="h6">Submit</Typography>
                </Button>
            )}

        </Box>
    )

}